var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionIconUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon icon_user",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    id: "ic_action_User"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.000000, -2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,3.9 C11.16,3.9 12.1,4.84 12.1,6 C12.1,7.16 11.16,8.1 10,8.1 C8.84,8.1 7.9,7.16 7.9,6 C7.9,4.84 8.84,3.9 10,3.9 Z M10,12.9 C12.97,12.9 16.1,14.36 16.1,15 L16.1,16.1 L3.9,16.1 L3.9,15 C3.9,14.36 7.03,12.9 10,12.9 Z M10,2 C7.79,2 6,3.79 6,6 C6,8.21 7.79,10 10,10 C12.21,10 14,8.21 14,6 C14,3.79 12.21,2 10,2 Z M10,11 C7.33,11 2,12.34 2,15 L2,18 L18,18 L18,15 C18,12.34 12.67,11 10,11 Z",
    id: "path-user",
    fill: "#0079ad",
    fillRule: "nonzero"
  })))));
}
export default __webpack_public_path__ + "static/media/ic-action-icon-user.2019d53d.svg";
export { SvgIcActionIconUser as ReactComponent };